import React from 'react';
import { Modal, Button, Alert } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface DuplicateWarning {
    has_duplicate: boolean;
    message: string;
    completed_date?: string;
    invited_date?: string;
    inviter_info?: string;
    test_name?: string;
    is_invitation_pending?: boolean;
}

interface Props {
    visible: boolean;
    warning: DuplicateWarning | null;
    onProceed: () => void;
    onCancel: () => void;
    loading?: boolean;
}

const DuplicateAssessmentModal: React.FC<Props> = ({
    visible,
    warning,
    onProceed,
    onCancel,
    loading = false
}) => {
    if (!warning || !warning.has_duplicate) return null;

    const isCompleted = !warning.is_invitation_pending;
    const timeframe = isCompleted ? 'completed' : 'invited to take';

    return (
        <Modal
            title={
                <div style={{ display: 'flex', alignItems: 'center', color: '#faad14' }}>
                    <ExclamationCircleOutlined style={{ marginRight: 8, fontSize: 20 }} />
                    Duplicate Assessment Warning
                </div>
            }
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Cancel Invitation
                </Button>,
                <Button
                    key="proceed"
                    type="primary"
                    onClick={onProceed}
                    loading={loading}
                    danger
                >
                    Proceed Anyway
                </Button>
            ]}
            width={600}
        >
            <Alert
                type="warning"
                description={
                    <div style={{ marginTop: 12 }}>
                        <p style={{ marginBottom: 16, fontSize: 14, lineHeight: 1.5 }}>
                            <strong>{warning.message}</strong>
                        </p>
                        <p style={{ marginBottom: 12, color: '#666', fontSize: 13 }}>
                            This warning appears to prevent candidates from receiving invitations for assessments
                            they may have recently {timeframe}, as they might already be familiar with the questions and answers.
                        </p>
                        <div style={{
                            background: '#fff7e6',
                            border: '1px solid #ffd591',
                            borderRadius: 6,
                            padding: 12,
                            fontSize: 13
                        }}>
                            <strong>Options:</strong>
                            <ul style={{ margin: '8px 0', paddingLeft: 20 }}>
                                <li><strong>Cancel:</strong> Don't send the invitation to avoid potential bias</li>
                                <li><strong>Proceed:</strong> Send the invitation anyway (candidate may have prior knowledge)</li>
                            </ul>
                        </div>
                    </div>
                }
            />
        </Modal>
    );
};

export default DuplicateAssessmentModal;